/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PlatformApiResultOfPlatformModeDto } from '../models/platform-api-result-of-platform-mode-dto';
import { getPlatformMode } from '../fn/platform-mode/get-platform-mode';
import { GetPlatformMode$Params } from '../fn/platform-mode/get-platform-mode';
import { postPlatformModeActionSet } from '../fn/platform-mode/post-platform-mode-action-set';
import { PostPlatformModeActionSet$Params } from '../fn/platform-mode/post-platform-mode-action-set';


/**
 * Platformmodi (issue #51): opvragen (iedereen, ook de loginpagina) en instellen (beheer).
 */
@Injectable({ providedIn: 'root' })
export class PlatformPlatformModeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPlatformMode()` */
  static readonly GetPlatformModePath = '/api/platform-mode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPlatformMode()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlatformMode$Response(params?: GetPlatformMode$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfPlatformModeDto>> {
    return getPlatformMode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPlatformMode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlatformMode(params?: GetPlatformMode$Params, context?: HttpContext): Observable<PlatformApiResultOfPlatformModeDto> {
    return this.getPlatformMode$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfPlatformModeDto>): PlatformApiResultOfPlatformModeDto => r.body)
    );
  }

  /** Path part for operation `postPlatformModeActionSet()` */
  static readonly PostPlatformModeActionSetPath = '/api/platform-mode/action/set';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postPlatformModeActionSet()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postPlatformModeActionSet$Response(params: PostPlatformModeActionSet$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfPlatformModeDto>> {
    return postPlatformModeActionSet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postPlatformModeActionSet$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postPlatformModeActionSet(params: PostPlatformModeActionSet$Params, context?: HttpContext): Observable<PlatformApiResultOfPlatformModeDto> {
    return this.postPlatformModeActionSet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfPlatformModeDto>): PlatformApiResultOfPlatformModeDto => r.body)
    );
  }

}
